import AntTime from './AntTime';

const DISPLAY_FORMAT = 'DD/MM/YYYY';

// Giá trị bộ lọc: { startDate, endDate } dạng Unix đầu ngày / cuối ngày — khớp với
// <field>_startDate / <field>_endDate mà AntSearchForm gửi và BE sqlSearchAdvance đọc.
export const normalizeDateFilter = (start, end) => {
    if (!start && !end) return null;
    let from = AntTime.startOfDay(start || end);
    let to = AntTime.endOfDay(end || start);
    if (from.unix() > to.unix()) {
        from = AntTime.startOfDay(end);
        to = AntTime.endOfDay(start);
    }
    return { startDate: from.unix(), endDate: to.unix() };
};

export const isValidDateFilter = (value) =>
    Boolean(value) && typeof value.startDate === 'number' && typeof value.endDate === 'number' && value.startDate <= value.endDate;

export const formatDateFilter = (value) => {
    if (!isValidDateFilter(value)) return '';
    const from = AntTime.fromUnix(value.startDate).format(DISPLAY_FORMAT);
    const to = AntTime.fromUnix(value.endDate).format(DISPLAY_FORMAT);
    return from === to ? from : `${from} – ${to}`;
};

// Chọn nhanh: today = hôm nay, yesterday = hôm qua, month = tháng này (ngày 1 → cuối tháng). now: Date (mặc định lúc này).
export const DATE_FILTER_PRESETS = ['today', 'yesterday', 'month'];

export const quickDateFilter = (preset, now) => {
    const base = now instanceof Date ? now : new Date();
    if (preset === 'today') return normalizeDateFilter(base, base);
    if (preset === 'yesterday') {
        const day = AntTime.startOfDay(base).subtract(1, 'day').toDate();
        return normalizeDateFilter(day, day);
    }
    if (preset === 'month') return { startDate: AntTime.startOfDay(base).startOf('month').unix(), endDate: AntTime.endOfDay(base).endOf('month').unix() };
    return null;
};

// Preset đang khớp giá trị lọc (để tô nút chọn nhanh), không khớp → null.
export const matchDateFilterPreset = (value, now) => {
    if (!isValidDateFilter(value)) return null;
    return (
        DATE_FILTER_PRESETS.find((preset) => {
            const range = quickDateFilter(preset, now);
            return range && range.startDate === value.startDate && range.endDate === value.endDate;
        }) || null
    );
};
